/**
 * 1. 提供各个 Layer 样式属性初始值的注册服务
 * 2. 当 Layer 通过 style() 改变某些样式属性时，需要感知并标记该属性已经失效，
 *    随后当 Layer 重绘时通过 dirty 标记进行脏检查。重新传入 uniform 或者构建顶点数据（更新 Buffer 中的指定位置）。
 * @see https://yuque.antfin-inc.com/yuqi.pyq/fgetpa/qfuzg8
 */
export var ScaleTypes;

(function (ScaleTypes) {
  ScaleTypes["LINEAR"] = "linear";
  ScaleTypes["SEQUENTIAL"] = "sequential";
  ScaleTypes["POWER"] = "power";
  ScaleTypes["LOG"] = "log";
  ScaleTypes["IDENTITY"] = "identity";
  ScaleTypes["TIME"] = "time";
  ScaleTypes["QUANTILE"] = "quantile";
  ScaleTypes["QUANTIZE"] = "quantize";
  ScaleTypes["THRESHOLD"] = "threshold";
  ScaleTypes["CAT"] = "cat";
  ScaleTypes["DIVERGING"] = "diverging";
})(ScaleTypes || (ScaleTypes = {}));

export var StyleScaleType;

(function (StyleScaleType) {
  StyleScaleType["CONSTANT"] = "constant";
  StyleScaleType["VARIABLE"] = "variable";
})(StyleScaleType || (StyleScaleType = {}));

export var AttributeType;

(function (AttributeType) {
  AttributeType[AttributeType["Attribute"] = 0] = "Attribute";
  AttributeType[AttributeType["InstancedAttribute"] = 1] = "InstancedAttribute";
  AttributeType[AttributeType["Uniform"] = 2] = "Uniform";
})(AttributeType || (AttributeType = {}));